import ReactDOM from 'react-dom';
import { Suspense, lazy } from 'react';
import { BrowserRouter } from 'react-router-dom';
//Redux Imports
import { store } from './redux/store';
import { Provider } from 'react-redux';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
//ThemeColors Context
import { ThemeContext } from './utility/context/ThemeColors';
//ThemeConfig
import themeConfig from './configs/themeConfig';
import { Toaster, toast } from 'react-hot-toast';
import { hotToastClassNames } from './helpers/showToast';
//Spinner (Splash Screen)
import Spinner from './@core/components/spinner/Fallback-spinner';
//Ripple Button
import './@core/components/ripple-button';
//PrismJS
import 'prismjs';
import 'prismjs/themes/prism-tomorrow.css';
import 'prismjs/components/prism-jsx.min';
//React Perfect Scrollbar
import 'react-perfect-scrollbar/dist/css/styles.css';
//React Hot Toast Styles
import '@styles/react/libs/react-hot-toasts/react-hot-toasts.scss';
//Core styles
import './@core/assets/fonts/feather/iconfont.css';
import './@core/scss/core.scss';
import './assets/scss/style.scss';
import { markBookingPersistenceErrorHandled } from './domain/agendamiento/booking';
import { getUnhandledBookingRejectionContext } from './domain/agendamiento/bookingUnhandledRejection';
//Service Worker
import * as serviceWorker from './serviceWorker';
import DevConsolePanel from './component/DevConsole';
import { envVar } from './configs/envirmentVar';
//Lazy load app
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: true,
      networkMode: 'alway',
    },
  },
});

const BOOKING_UNHANDLED_REJECTION_HANDLER_KEY =
  '__bookingUnhandledRejectionHandlerRegistered__';

const registerBookingUnhandledRejectionHandler = () => {
  if (
    typeof window === 'undefined' ||
    window[BOOKING_UNHANDLED_REJECTION_HANDLER_KEY]
  ) {
    return;
  }

  window.addEventListener('unhandledrejection', (event) => {
    const bookingRejection = getUnhandledBookingRejectionContext(event);
    if (!bookingRejection) {
      return;
    }

    markBookingPersistenceErrorHandled(bookingRejection.error);
    toast.error(bookingRejection.message);
    event.preventDefault();
  });
  window[BOOKING_UNHANDLED_REJECTION_HANDLER_KEY] = true;
};

registerBookingUnhandledRejectionHandler();

const isConsole = envVar.REACT_APP_COMPONENT_CONSOLE;

const LazyApp = lazy(() => import('./App'));
ReactDOM.render(
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <Provider store={store}>
        <Suspense fallback={<Spinner />}>
          <ThemeContext>
            {/*isConsole === 'enabled' ? <DevConsolePanel /> : null*/}
            <LazyApp />
            <Toaster
              position={themeConfig.layout.toastPosition}
              toastOptions={{ className: hotToastClassNames.default }}
            />
          </ThemeContext>
        </Suspense>
      </Provider>
    </BrowserRouter>
    <ReactQueryDevtools initialIsOpen={false} />
  </QueryClientProvider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
